import { styled } from "styled-components";

export const Wrapper = styled.a`

`

export const LetterImg = styled.img`
  width: 35px;
  height: 35px;
`

export const LogoImg = styled.img `
  width: 129px;
  height: auto;
`

